export default function AboutSection() {
  const stats = [
    { number: "10,000+", label: "Products Listed" },
    { number: "14+", label: "Categories Covered" },
    { number: "99%", label: "Satisfaction Rate" },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-6 md:px-10 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[55%]">
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
              Why OOPBuy
              <br />
              Spreadsheet
              <br />
              Saves You Time
            </h2>

            <div className="mt-10 grid grid-cols-3 gap-6 divide-x divide-background-300">
              {stats.map((stat, idx) => (
                <div key={idx} className={idx > 0 ? "pl-6" : ""}>
                  <div className="text-3xl md:text-4xl font-bold text-primary-500">
                    {stat.number}
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-snug">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>

            <p className="mt-8 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              The OOPBuy spreadsheet system organizes thousands of products into structured comparison tables, helping buyers evaluate prices, quality ratings, and shipping estimates at a glance. No more juggling dozens of browser tabs — everything you need in one organized view.
            </p>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Explore the Spreadsheet System
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:w-[45%] relative">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-gradient-to-br from-primary-100 via-accent-50 to-background-50">
              <div className="absolute top-8 left-8 w-32 h-32 rounded-2xl bg-primary-200/50 rotate-12"></div>
              <div className="absolute top-20 right-10 w-40 h-28 rounded-2xl bg-accent-200/50 -rotate-6"></div>
              <div className="absolute bottom-12 left-16 w-36 h-24 rounded-2xl bg-secondary-200/50 rotate-[15deg]"></div>
              <div className="absolute bottom-20 right-16 w-28 h-28 rounded-full bg-primary-100/60"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-2xl bg-accent-100/40 rotate-45"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}